import { NgModule } from '@angular/core';
import { IntlModule } from '@progress/kendo-angular-intl';
import { UtilityService } from '@shared/module/common/services/utility.service';
import { ReplaceHostDirective } from '@shared/module/common/directives/replace-host.directive';
import { DisableControlDirective } from '@shared/module/common/directives/disable-control.directive';
import { HtmlSanitizerPipe } from '@shared/module/common/pipe/html-sanitizer.pipe';
import { CommonModule as AngularCommonModule } from '@angular/common';
import { ImagePreloaderDirective } from '@shared/module/common/directives/image-preloader.directive';
import { InfiniteScrollDirective } from '@shared/module/common/directives/infinite-scroll.directive';
import { KendoRtlDirective } from '@shared/module/common/directives/kendo-rtl.directive';
import { ParsingDataPipe } from '@shared/module/common/pipe/parsing-data.pipe';
import { UrlSanitizerPipe } from '@shared/module/common/pipe/url-sanitizer.pipe';

const DIRECTIVES = [ReplaceHostDirective, DisableControlDirective, ImagePreloaderDirective, InfiniteScrollDirective, KendoRtlDirective];

@NgModule({
    imports: [AngularCommonModule, IntlModule],
    declarations: [...DIRECTIVES, HtmlSanitizerPipe, ParsingDataPipe, UrlSanitizerPipe],
    exports: [AngularCommonModule, IntlModule, ...DIRECTIVES, HtmlSanitizerPipe, ParsingDataPipe, UrlSanitizerPipe],
    providers: [UtilityService],
})
export class SharedCommonModule {}



// WEBPACK FOOTER //
// ./src/shared/module/common/common.module.ts